import Flickity from "react-flickity-component";
import CardComponentCaraCerdas from "../LiterasiKeuangan/CardComponentCaraCerdas";

const SliderCaraCerdasMobile = ({ relatedTo }) => {
  const flickityOptions = {
    contain: true,
    groupCells: 1,
    cellAlign: "left",
    prevNextButtons: true,
    freeScroll: true,
    pageDots: false,
    draggable: true,
  };
  return (
    <div className="carousel-wrapper-CardCaraCerdas-mobile">
      <div className="carousel-container-CardCaraCerdas-mobile">
        <Flickity
          options={flickityOptions}
          className={"carousel"}
          elementType={"div"}
        >
          <CardComponentCaraCerdas relatedTo={relatedTo} />
        </Flickity>
      </div>
      <style jsx>
        {`
          .carousel-wrapper-CardCaraCerdas-mobile {
            max-width: 940px;
            width: 100%;
            align-self: center;
          }
          .carousel-container-CardCaraCerdas-mobile {
            margin-left: 12px;
          }
        `}
      </style>
    </div>
  );
};

export default SliderCaraCerdasMobile;
